/**
 * h5数据上报
 * @author dzq
 */
import { getCxid } from "./cxid";
import MgStat from "@mgtv/mba";
import { getLastp } from "./cntp";
import { getStorage } from "../utils/storage";
import { getQuery } from "../utils/url";

/**
 * 上报公共参数
 */
const getCommonParams = () => {
  return {
    lastp: getLastp() || getStorage("superlive-lastp"),
    ch: getCxid(),
  };
};

/**
 * 上报pv
 * @param {Object} lob
 */
export const statPv = (lob = {}) => {
  MgStat?.send("pv", lob, {
    ...getCommonParams(),
  });
};

/**
 * 上报stay 开始
 * @param {*} lob
 */
export const statStayBegin = (lob = {}) => {
  MgStat?.stayhand?.startTick(
    {
      ...lob,
      actid: getQuery("actId") || "",
    },
    {
      ...getCommonParams(),
      url: window.location.href,
    }
  );
};

/**
 * 上报stay 结束
 */
export const statStayEnd = () => {
  MgStat?.stayhand?.endTick();
};

/**
 * 点击上报
 * @param {Object} lob
 * @param {Object} params
 */
export function statClick(lob, params) {
  MgStat?.send(
    "click",
    {
      ...lob,
      act: "click",
    },
    {
      ...getCommonParams(),
      label: "btn",
      direct: "cntp",
      addr: "",
      ...params,
    }
  );
}

/**
 * 控件曝光上报
 * @param {Object} lob
 * @param {Object} params
 */
export const statCv = (lob = {}, params = {}) => {
  setTimeout(() => {
    MgStat?.send("cv", lob, {
      ...getCommonParams(),
      ...params,
    });
  }, 1000);
};

/**
 * 控件曝光上报
 * @param {Object} lob
 * @param {Object} params
 */
export const statShow = (lob = {}, params = {}) => {
  setTimeout(() => {
    MgStat?.send("show", lob, {
      ...getCommonParams(),
      ...params,
    });
  }, 100);
};
